import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {Form, Input, Button, Checkbox} from "antd";
import {Row, Alert} from "antd";
import {useTranslation} from "react-i18next";
import {UserOutlined} from "@ant-design/icons";
import {authActions} from "_actions";
import {Link} from "react-router-dom";
import {history} from '_helpers/history'
import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import prefooter from "../../assets/img/prefooter.svg";
import {isMobile, isTablet} from 'react-device-detect';

function LoginPage(props) {

    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    var userLogin = useSelector((state) => state.authReducer.user);
    var errorLogin = useSelector((state) => state.authReducer.error);
    var actualYear = useSelector((state) => state.authReducer.actualYear);

    useEffect(() => {
        if (!actualYear) {
            dispatch(authActions.actualYear())

        }
    }, [])


    useEffect(() => {
        setLoading(false);
        if (userLogin) {
            if (userLogin.user.changepass) {
                history.push("/auth/resetpassword");
            }
            setError(false);
            setErrorMsg("");
        }
        if (errorLogin) {

            setError(true);
            setErrorMsg(t(errorLogin.code));
        }
    }, [userLogin, errorLogin]);

    const onFinish = async (values) => {

        setError(false);
        setErrorMsg("");
        setLoading(true);
        dispatch(authActions.login(values.email, values.password, values.remember, (isMobile && !isTablet) ? "MOBILE" : isTablet ? "TABLET" : "DESKTOP"))

    };

    return (
        <>
            <NavbarNoLogin className="menuNavLogin"/>
            <div className="containerRowLogin">

                <div className="colRegister leftLogin">
                    <h1>{t("welcomea")}</h1>
                </div>
                <div className="colRegister rightLogin">
                    <div className={"formLogin"}>
                        <div>
                            <h3>{t("login.ini")}</h3>
                            <div className="customTextMedium is-required">{t("obligatorio")}</div>
                            <div className="centerMobile">
                                <Form
                                    name="normal_login"
                                    className="authForm allHeightMobile"
                                    layout="vertical"
                                    labelCol={{span: 22}}
                                    wrapperCol={{span: 22}}
                                    initialValues={{
                                        remember: true,
                                    }}
                                    onFinish={onFinish}
                                >


                                    <div style={{marginTop: 16}}></div>

                                    <Form.Item
                                        label={t("login.email")}
                                        name="email"
                                        rules={[
                                            {
                                                type: "email",
                                                message: t("login.emailIncorrect"),
                                            },
                                            {
                                                required: true,
                                                message: t("login.emailMandatory"),
                                            },
                                        ]}
                                    >
                                        <Input
                                            prefix={<UserOutlined className="site-form-item-icon colorBlue"/>}
                                            placeholder={t("login.emailp")}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t("login.password")}
                                        name="password"
                                        style={{marginBottom: 8}}
                                        rules={[
                                            {
                                                required: true,
                                                message: t("login.passwordMandatory"),
                                            },
                                        ]}
                                    >
                                        <Input.Password
                                            placeholder={t("login.passwordp")}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="remember"
                                        valuePropName="checked"
                                        style={{marginBottom: 16}}
                                    >
                                        <Checkbox style={{color: "white"}}>{t("login.rememberMe")}</Checkbox>
                                    </Form.Item>


                                    <Row>
                                        <Link style={{marginTop: 0, marginBottom: 24}} className="linkForgot"
                                              to="/auth/forgot">{t("login.forgotPassword")}</Link>
                                    </Row>


                                    <Form.Item>
                                        <Button
                                            loading={loading}
                                            htmlType="submit"
                                            className="primaryButton buttonSizeXL"
                                            type="primary"
                                        >
                                            {t("login.login")}
                                        </Button>
                                        {error && <Alert message={errorMsg} type="error"/>}
                                    </Form.Item>
                                </Form>
                                <div className={"registerLogin"}>
                                    <p style={{marginBottom: 8}}>{t("login.primera")}</p>
                                    <p className={"customTextMedium"}>{t("login.crea")}</p>
                                    <div>
                                        <Button
                                            href={"/auth/register"}
                                            className="btnPrimaryWhite"
                                            style={{width: 150}}
                                        >
                                            {t("home.student")}
                                        </Button>
                                        <Button
                                            href={"/tutorAuth/register"}
                                            className="btnPrimaryWhite"
                                        >
                                            {t("home.tutor")}
                                        </Button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="prefooter">
                <img className="prefooter-img" src={prefooter} alt={""}/>
            </div>
        </>
    );
}

export default withTranslation()(LoginPage);
